import { Pipe, PipeTransform } from '@angular/core';

const CATEGORY_KEY_MAP: Record<string, string> = {
  'shopping cart': 'NOTIFICATIONS.CATEGORIES.SHOPPING_CART',
  accounts: 'NOTIFICATIONS.CATEGORIES.ACCOUNTS',
  sales: 'NOTIFICATIONS.CATEGORIES.SALES',
  billing: 'NOTIFICATIONS.CATEGORIES.BILLING',
  'bulk actions': 'NOTIFICATIONS.CATEGORIES.BULK_ACTIONS',
  task: 'NOTIFICATIONS.CATEGORIES.TASK',
  export: 'NOTIFICATIONS.CATEGORIES.EXPORT',
  automations: 'NOTIFICATIONS.CATEGORIES.AUTOMATIONS',
  'business center': 'NOTIFICATIONS.CATEGORIES.BUSINESS_CENTER',
  vendor: 'NOTIFICATIONS.CATEGORIES.VENDOR',
  crm: 'NOTIFICATIONS.CATEGORIES.CRM',
  'email configuration': 'NOTIFICATIONS.CATEGORIES.EMAIL_CONFIGURATION',
  reporting: 'NOTIFICATIONS.CATEGORIES.REPORTING',
  conversations: 'NOTIFICATIONS.CATEGORIES.CONVERSATIONS',
  knowledge: 'NOTIFICATIONS.CATEGORIES.KNOWLEDGE',
  fulfillment: 'NOTIFICATIONS.CATEGORIES.FULFILLMENT',
  announcements: 'NOTIFICATIONS.CATEGORIES.ANNOUNCEMENTS',
  connections: 'NOTIFICATIONS.CATEGORIES.CONNECTIONS',
  quotes: 'NOTIFICATIONS.CATEGORIES.QUOTES',
  social: 'NOTIFICATIONS.CATEGORIES.SOCIAL',
  snapshot: 'NOTIFICATIONS.CATEGORIES.SNAPSHOT',
  'the loop': 'NOTIFICATIONS.CATEGORIES.THE_LOOP',
  website: 'NOTIFICATIONS.CATEGORIES.WEBSITE',
  support: 'NOTIFICATIONS.CATEGORIES.SUPPORT',
  'ai credits': 'NOTIFICATIONS.CATEGORIES.AI_CREDITS',
};

@Pipe({ name: 'categoryKey', standalone: false })
export class CategoryKeyPipe implements PipeTransform {
  transform(category: string): string {
    if (!category) return category;
    return CATEGORY_KEY_MAP[category.toLowerCase()] ?? category;
  }
}
